export default __webpack_public_path__ + "static/title_left-8e662e3c3feaf671fcabb2e59f62f9b0.png";